'use client';

import { useEffect } from 'react';
import { registerAppModules, initializeAppModules, destroyAppModules } from '@/lib/modules';

/**
 * 应用模块初始化 Hook
 * 负责在应用启动时注册和初始化所有功能模块
 *
 * 使用方式:
 * - 在 RootLayout 或顶层 Provider 中调用
 * - 仅在客户端执行
 */
export function useAppModules() {
  useEffect(() => {
    // 注册所有模块
    registerAppModules();

    // 初始化所有模块
    initializeAppModules().catch(error => {
      console.error('[useAppModules] Failed to initialize modules:', error);
    });

    // 清理函数
    return () => {
      destroyAppModules();
    };
  }, []); // 空依赖数组,仅在组件挂载时执行一次
}
